import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { List } from '@tesla/design-system-react';
import CountryAndLanguage from './CountryAndLanguage.js';

var CountryList = function CountryList(_ref) {
  var countries = _ref.countries,
    selected = _ref.selected,
    regionName = _ref.regionName,
    t = _ref.t,
    userLocale = _ref.userLocale;
  return /*#__PURE__*/React.createElement(List, {
    is: "ol",
    variant: "horizontal"
  }, countries.map(function (c) {
    return /*#__PURE__*/React.createElement(CountryAndLanguage, _extends({}, c, {
      key: c.countryCode,
      selected: selected === regionName,
      t: t,
      userLocale: userLocale
    }));
  }));
};
CountryList.propTypes = {
  countries: arrayOf(shape({
    countryCode: string
  })).isRequired,
  selected: string.isRequired,
  regionName: string.isRequired,
  t: shape({
    signout: string,
    allCountries: string,
    supportLink: string
  }).isRequired,
  userLocale: shape({
    countryName: string,
    regionName: string
  }).isRequired
};

export { CountryList as default };
